var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-4 pt-4 h3"},[_vm._v(_vm._s(_vm.labelTitle))]),_c('b-btn',{staticClass:"mt-2",on:{"click":_vm.makeOnline}},[_vm._v(" "+_vm._s(_vm.labelOptViewOnline)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }